// extracted by mini-css-extract-plugin
export default {"container":"BarsGraph_container__HFeUs","bar":"BarsGraph_bar__A5WMM","growFromBottom":"BarsGraph_growFromBottom__DnBhO"};